<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">

    <header id="m_header" class="m-grid__item m-header " m-minimize-offset="200" m-minimize-mobile-offset="200">
      <div class="m-container m-container--fluid m-container--full-height">
        <div class="m-stack m-stack--ver m-stack--desktop">
          <!-- BEGIN: Brand -->

          <sm-menu></sm-menu>

          <!-- MD and up menu -->
          <!-- END: Brand -->
          <div class="d-none d-md-block m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
            <!--BEGIN: Topbar-->
            <div id="m_header_menu" class="clearfix m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-light m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark flex full-width">
              <left-menu></left-menu>
              <main-menu></main-menu>
            </div>

            <!-- END: Topbar -->
          </div>
        </div>
      </div>
    </header>

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">

      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content" :class="{'agenda' : $route.name === 'agenda.index'}">

          <event-hub></event-hub>

          <transition name="fade" mode="out-in">
            <router-view
              :message="message"
              @messageEvent="message = $event"
            ></router-view>
          </transition>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MainMenu from '../components/Menu'
  import SmMenu from '../components/SmMenu.vue'
  import LeftMenu from '../components/LeftMenu/LeftMenu.vue'

  export default {
    components: {
      'main-menu': MainMenu,
      'sm-menu': SmMenu,
      'left-menu': LeftMenu,
    },
    data() {
      return {
        message: null
      }
    },
    watch: {
      message: function () {
        setTimeout(() => this.message = null, 3000)
      }
    }
  }
</script>

<style lang="scss">
  @import '../../node_modules/vue-awesome-notifications/dist/styles/style';

  .flex {
    display: flex !important
  }

  .full-width {
    width: 100%;
  }

  .form-group {
    .form-control-feedback {
      display: none;
    }
    &.show-feedback {
      .form-control-feedback {
        display: block;
      }
    }
  }

  .agenda {
    &.m-content {
      padding-top: 0 !important;
    }
    &.m-content {
      padding-left: 15px !important;
    }
  }

  .m-header-menu {
    float: right;
  }
</style>




// WEBPACK FOOTER //
// src/views/Main.vue